import { resolveSoa } from 'dns';
import React from 'react';


export const useRest = () => {
  return {
    mainFetch: async <T>(url: string, requestInit: RequestInit) => await fetch(url, requestInit).then(res => res.json()) as T
  }
}